var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "white",
    stroke: "#C5C5C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.4474 20C7.99561 20 6 17.9492 6 15.4004C6 14.1699 6.45614 12.998 7.28289 12.1484L13.2982 5.9668C13.9254 5.35156 14.8092 5 15.6645 5C17.8026 5 19 6.78711 19 8.39844C19 9.30664 18.6294 10.1855 18.0022 10.8301L12.5 16.4844C12.0724 16.9238 11.5022 17.1289 10.9605 17.1289C9.22149 17.1289 8.76535 15.5469 8.76535 14.9023C8.76535 14.3457 8.99342 13.7598 9.42105 13.3203L13.4693 9.16016C13.6404 8.98438 13.8399 8.92578 14.0395 8.92578C14.4671 8.92578 14.8377 9.27734 14.8377 9.74609C14.8377 9.95117 14.7522 10.1562 14.6096 10.332L10.5329 14.4922C10.4189 14.6094 10.3618 14.7559 10.3618 14.9023C10.3618 15.2539 10.6469 15.5176 10.9605 15.5176C11.1031 15.5176 11.2456 15.459 11.3596 15.3418L16.8904 9.6582C17.2039 9.30664 17.375 8.86719 17.375 8.39844C17.375 7.57812 16.7763 6.64062 15.6645 6.64062C15.2083 6.64062 14.7522 6.81641 14.4386 7.13867L8.42325 13.3203C7.88158 13.877 7.59649 14.6094 7.59649 15.4004C7.59649 16.8066 8.5943 18.3301 10.4474 18.3301C11.2171 18.3301 11.9583 18.0664 12.5 17.5098L17.0329 12.8223C17.2039 12.6758 17.4035 12.5879 17.6031 12.5879C18.0307 12.5879 18.4013 12.9395 18.4013 13.4082C18.4013 13.6133 18.3158 13.8184 18.1732 13.9941L13.6118 18.6523C12.7851 19.5312 11.6447 20 10.4474 20Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.57a8a8611282e91f7138ac908687a307.svg";
export { ForwardRef as ReactComponent };